//helper goes here for Projects
import covax19 from "../../assets/images/covax19.png"
import bootstrapbill from "../../assets/images/bootstrapbill.jpg"
import laptop from "../../assets/images/ll.png"
import yeetcode from "../../assets/images/yeetcode.png"

export type ProjectsProps = {}
export const projects =
    [
        {
            title: "Bootstrap Bill",
            description: `A full stack react app that 
        allows users to create, view, save and 
        generate reports regarding their budget`,
            image: bootstrapbill,
            link: "https://bootstrap-bill.netlify.app/"
        },
        {
            title: "Covax19",
            description: `A MERN stack app aggregating reviews from users
        who took the vaccine while also allowing anyone to post their
        thoughts for free`,
            image: covax19,
            link: "https://covax19.netlify.app/"
        },
        {
            title: "Lightning Laptop",
            description: `A MERN stack app that automatically filters out bad quality laptops
        and allows users to pick a laptop based on different criteria.`,
            image: laptop,
            link: "https://lightning-laptop.netlify.app/"
        },
        {
            title: "Yeetcode",
            description: `A simple JS library allowing users to configure
        and write unit tests in addition to logging the
        results to file`,
            image: yeetcode,
            link: "https://www.npmjs.com/package/yeetcode"
        }
    ]
export { }
